/*
// @ts-nocheck
@ts-ignore
 */
import { useEffect } from "react";

import _ from "lodash";
import * as yup from "yup";

import { objectNested } from "../services/common-service";
import { getStorage, mergeStorage, omitStorage, putStorage, useStorageListener } from "./useStorage";

import { EForms } from "types/enums";

type TPorps = {
    name: EForms;
    schema?: (yup: any, object: any) => any;
    onChange?: (data: any) => any;
};

type TReturn = {
    data: any;
    getValue: (field: string) => any;
    setValue: (path: string, value: any) => void;
    setValues: (values: Object) => void;
    removeValue: (value: string) => void;
    onSubmit: (handleSubmit: (e: any) => any) => (e: any) => void;
    setErrors: (errors: Object) => void;
    clearErrors: () => void;
    clearForm: () => void;
    readOnly: boolean;
    setReadOnly: (newValue: boolean) => void;
};

const useFormControl = (options: TPorps): TReturn => {
    const { name, schema, onChange = () => {} } = options;
    // READ ONLY
    const readOnly = useStorageListener((state) => _.get(state, `forms.${name}.readOnly`)) === true;
    const setReadOnly = (newValue: boolean) => {
        if (!!name) {
            putStorage(`forms.${name}.readOnly`, newValue);
        }
    };

    // DATA
    const data = useStorageListener((state) => _.get(state, `forms.${name}.values`, {}));
    const getValue = (field: string) => _.get(data, field);
    const setValue = (path: string, value: any) => {
        if (!!name && !!path) {
            putStorage(`forms.${name}.values.${path}`, value);
        }
    };
    const setValues = (values: Object) => {
        if (!_.isObject(values)) {
            throw new Error(`[useFormControl] values must be an object`);
        }
        if (!!name) {
            mergeStorage(`forms.${name}.values`, values);
        }
    };
    const removeValue = (value: string) => {
        (Array.isArray(value) ? value : [value]).forEach((i) => {
            omitStorage(`forms.${name}.values.${i}`);
        });
    };
    const clearForm = () => {
        omitStorage(`forms.${name}`);
    };

    // ERRORS
    const setErrors = (errors: Object) => {
        putStorage(`forms.${name}.errors`, errors);
    };
    const clearErrors = () => {
        omitStorage(`forms.${name}.errors`);
    };

    // SUBMIT
    const onSubmit = (handleSubmit: (e: any) => any) => async (e: any) => {
        try {
            e?.preventDefault?.();
            const data = getStorage((state) => _.get(state, `forms.${name}.values`) ?? {});
            if (schema) {
                await schema(yup, data).validate(data, { abortEarly: false });
                setErrors({});
            }
            handleSubmit(data);
        } catch (error: any) {
            console.warn(error);
            console.warn(`Form validation error`, Object.fromEntries(error?.inner?.map?.((e: any) => [e?.path, { message: e?.message }]) ?? []));
            setErrors(objectNested(Object.fromEntries(error?.inner?.map?.((e: any) => [e?.path, { message: e?.message }]) ?? [])));
            // error?.inner?.forEach(({ path, message }: any) => AlertsService.showError(`${path}: ${message}`));
        }
    };

    useEffect(() => onChange(data), [data]);

    return {
        data,
        getValue,
        setValue,
        setValues,
        removeValue,
        onSubmit,
        setErrors,
        clearErrors,
        clearForm,
        readOnly,
        setReadOnly,
    };
};

export default useFormControl;
